// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__M0UN5","colMaxWidth":"Table_colMaxWidth__1_RYc"};